import { useApiHealth } from '@/lib/api/health'
import { cn } from '@/lib/utils'

/** Small dot + label showing whether the backend and its dependencies are reachable. */
export function ApiStatus({ className }) {
  const { data, isPending, isError } = useApiHealth()
  const state = isPending ? 'checking' : isError ? 'offline' : data.status
  const styles = {
    checking: ['bg-muted-foreground', 'Checking API…'],
    ok: ['bg-success', 'All systems operational'],
    degraded: ['bg-warning', 'Some services degraded'],
    offline: ['bg-destructive', 'API unreachable'],
  }[state]
  return (
    <span className={cn('inline-flex items-center gap-2 text-xs text-muted-foreground', className)} role="status">
      <span className={cn('size-2 rounded-full', styles[0])} aria-hidden="true" />
      {styles[1]}
    </span>
  )
}
